// ERP Attribute Engine — Visibility Processor
import { evaluateConditionalRules } from './conditionEvaluator';

export function computeVisibility(solution, attributes, groups, rolePermission, role, values) {
  const computedState = evaluateConditionalRules(solution.conditionalRules || [], values);

  const visibleAttributeIds = new Set();
  const editableAttributeIds = new Set();

  for (const [id, attr] of attributes) {
    if (computedState.hidden.has(id)) continue;
    if (!canViewAttribute(attr, rolePermission, role)) continue;
    visibleAttributeIds.add(id);
    if (!computedState.disabled.has(id) && canEditAttribute(attr, rolePermission)) {
      editableAttributeIds.add(id);
    }
  }

  const visibleGroupIds = new Set();
  for (const [groupId, group] of groups) {
    if (computedState.hidden.has(groupId)) continue;
    if (group.visibilityRoles && !group.visibilityRoles.includes(role)) continue;
    const hasVisible = group.attributeIds.some(id => visibleAttributeIds.has(id));
    if (hasVisible) visibleGroupIds.add(groupId);
  }

  return { visibleAttributeIds, editableAttributeIds, visibleGroupIds, computedState };
}

export function canViewAttribute(attr, rolePermission, role) {
  if (attr.systemField && role !== 'sys-admin') return false;
  const list = rolePermission.canViewAttributeIds;
  return list.includes('*') || list.includes(attr.id);
}

export function canEditAttribute(attr, rolePermission) {
  if (attr.readOnly) return false;
  const list = rolePermission.canEditAttributeIds;
  return list.includes('*') || list.includes(attr.id);
}
